module.exports = __webpack_public_path__ + "ipm.0ba90f4f6db37dde4bfc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ipm.svg
// module id = 88
// module chunks = 2